import axios from 'axios'

class Banner {
    get(bannerId) {
        return axios.get(`/api/v1/banners/${bannerId}`)
    }

    remove(bannerId) {
        return axios.delete(`/api/v1/banners/${bannerId}`)
    }

    edit(data, bannerId) {
        return axios.post(`/api/v1/banners/${bannerId}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }

    create(data) {
        return axios.post(`/api/v1/banners`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }
}

export default Banner
